import { CircularProgress, CircularProgressProps } from '@mui/material';
import { forwardRef } from 'react';

type Props = Pick<
  CircularProgressProps,
  'size' | 'className' | 'sx' | 'color' | 'aria-labelledby'
> & {
  testId?: string;
};

const Loading = forwardRef<HTMLSpanElement, Props>(
  ({ size, className, sx, color, testId, 'aria-labelledby': ariaLabelledBy }, ref) => (
    <CircularProgress
      size={size}
      className={className}
      sx={sx}
      color={color}
      aria-labelledby={ariaLabelledBy}
      test-id={testId}
      ref={ref}
    />
  ),
);

Loading.displayName = 'Loading';
export type { Props as LoadingProps };
export default Loading;
